export default "__VITE_ASSET__BMJOo19Q__"